// ABOUTME: Main application layout wrapper with header, footer, and global CSS injection.
// ABOUTME: Injects site-wide custom CSS from app_settings with highest priority.

import { type ReactNode, useEffect } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { useAppSettings } from '@/hooks/useAppSettings';

interface AppLayoutProps {
  children: ReactNode;
  hideFooter?: boolean;
}

export const AppLayout = ({ children, hideFooter = false }: AppLayoutProps) => {
  const { settings } = useAppSettings();

  useEffect(() => {
    let styleTag = document.getElementById('global-custom-css') as HTMLStyleElement | null;
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'global-custom-css';
      document.head.appendChild(styleTag);
    }
    styleTag.textContent = settings.global_css || '';
  }, [settings.global_css]);

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
};
